import { useToast } from "@mallardbay/lib-react-components"

import type {
    UpdateWishlistInput,
    WishlistFieldsFragment,
} from "~graphql/generated/graphql"
import { useUpdateWishlistMutation } from "~graphql/generated/graphql"

export function useUpdateWishlist({
    onCompleted,
}: {
    onCompleted?: (updatedWishlist: WishlistFieldsFragment) => void
} = {}) {
    const { showError } = useToast()

    const [updateWishlistMutation, { loading: isLoading }] =
        useUpdateWishlistMutation({
            onCompleted: (data) => {
                if (onCompleted) {
                    onCompleted(data.updateWishlist)
                }
            },
            onError: () => showError(),
        })

    const updateWishlist = (id: string, data: UpdateWishlistInput) => {
        return updateWishlistMutation({ variables: { id, data } })
    }

    return { updateWishlist, isLoading }
}
